var _tspan;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "7.04mm",
    height: "70.58mm",
    viewBox: "0 0 19.94 200.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "stoke",
    x1: 9.97,
    y1: 115.88,
    x2: 9.97,
    y2: 185.71,
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "stoke",
    points: "0 182.79 9.97 200.06 19.94 182.79 0 182.79",
    style: {
      fill: "#231f20",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(9.8 .32)",
    style: {
      fill: "#231f20",
      fontFamily: "MuseoSans-900, &apos",
      fontSize: 18,
      glyphOrientationVertical: "0deg",
      textOrientation: "upright",
      writingMode: "tb"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "NEXT"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScroll);
export default __webpack_public_path__ + "static/media/scroll.1e649958aede68cac621958c1ee9aaae.svg";
export { ForwardRef as ReactComponent };